var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trainer-apply-qrcode"},[_c('avatar-header',{attrs:{"avatar":_vm.coach.avatar,"title":("绑定您的私人教练：" + (_vm.coach.name))}}),_vm._v(" "),_c('qr-code',{attrs:{"step-count":3,"current-step":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09efef0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/trainer_apply/QRCode.vue
// module id = null
// module chunks = 